import React, { useState } from "react";
import { Card, Checkbox, Grid, Tab } from "semantic-ui-react";
import Divider from "../../../app/common/components/Divider";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdmin,
  getCompanyFeaturedLogoRequestsToReview,
  getUnderReviewCompanyFeaturedLogosFreebies,
} from "../adminSelectors";
import sortBy from "lodash/sortBy";
import AdminReviewFeaturedCompanyLogoRequest from "./AdminReviewFeaturedCompanyLogoRequest";
import PromotionServicesList from "../../employer/components/PromotionServicesList";
import {
  COMPANY_PROMOTION_FEATURED_LOGO,
  PROMOTION_SERVICE_TYPE,
} from "../../employer/employerConstanst";
import { CLF_PROMOTION_TYPE } from "../adminConstants";
import useFirestoreCollection from "../../../../src/app/hooks/useFirestoreCollection";
import { listenToPromotionCompanyFeaturedLogosFromFirestore } from "../../../../src/app/firestore/firestoreService";
import { QUERY_CODES } from "../../../../src/app/firestore/firestoreConstants";
import { fetchCompanyFeaturedLogos } from "../../../../src/features/promotions/promotionsActions";

export default function ReviewCompanyPromotionRequests() {
  const dispatch = useDispatch();

  const { promotionServices, underReviewFreebies } = useSelector((state) =>
    getAdmin(state)
  );
  const { companyFeaturedLogos } = useSelector((state) => state.promotions);

  const [
    isShowActiveCompanyFeaturedLogos,
    setIsShowActiveCompanyFeaturedLogos,
  ] = useState(false);

  const itemsToReview = sortBy(
    [
      ...getCompanyFeaturedLogoRequestsToReview(promotionServices),
      ...getUnderReviewCompanyFeaturedLogosFreebies(underReviewFreebies),
    ],
    "datePurchased"
  );

  function handleShowActivePromotions(e, { checked }) {
    setIsShowActiveCompanyFeaturedLogos(checked);
  }

  useFirestoreCollection({
    query: () => listenToPromotionCompanyFeaturedLogosFromFirestore("CY"),
    data: (logos) => dispatch(fetchCompanyFeaturedLogos(logos)),
    deps: [dispatch],
    queryCode: QUERY_CODES.listenToPromotionCompanyFeaturedLogosFromFirestore,
  });

  const REVIEW_TAB = (
    <Grid>
      <Grid.Column width={16}>
        <br />
        <div style={{ marginTop: 15 }}>
          {itemsToReview.length > 0 ? (
            <Card.Group>
              {itemsToReview.map((logo) => (
                <AdminReviewFeaturedCompanyLogoRequest
                  logo={logo}
                  key={logo.id}
                  type={CLF_PROMOTION_TYPE.underReview}
                />
              ))}
            </Card.Group>
          ) : (
            <span className="manage-item-list-no-item">None</span>
          )}
        </div>
        <Divider dividerLine="1px solid #bce0fd" margin={"80px 0 30px"} />
        <div className="body-blue-text semi-bold">Active promotions</div>
        <Checkbox
          style={{ marginRight: 10, paddingTop: 2 }}
          label="Show"
          onChange={(e, { checked }) =>
            handleShowActivePromotions(e, { checked })
          }
        />
        {isShowActiveCompanyFeaturedLogos && (
          <div style={{ marginTop: 15 }}>
            <PromotionServicesList
              promotionType={PROMOTION_SERVICE_TYPE.active}
              promotions={companyFeaturedLogos}
              promotionItemType={COMPANY_PROMOTION_FEATURED_LOGO}
              heading="Active"
              noPromotionsHeading="No active promotions"
              isAdmin={true}
              // loading={loading}
            />
          </div>
        )}
      </Grid.Column>
    </Grid>
  );

  const panes = [
    {
      menuItem: `Review (${itemsToReview.length})`,
      render: () => <Tab.Pane>{REVIEW_TAB}</Tab.Pane>,
    },
  ];

  return <Tab panes={panes} renderActiveOnly={true} />;
}
